import { type TypeComponentAssetGridEntry } from '@contentful-types/component-asset-grid'

import { AssetGrid } from '@components/asset-grid/asset-grid'

import { getContentfulAssetProps } from '../asset-image/utils'

type ComponentAssetGridProps = {
  data: TypeComponentAssetGridEntry
}

export default function ComponentAssetGrid({ data }: ComponentAssetGridProps) {
  const {
    fields: { assets },
  } = data

  const assetsData = assets?.map(asset => getContentfulAssetProps(asset?.fields?.asset)) ?? []

  return <AssetGrid assets={assetsData} />
}
